import { CommonResponse } from 'models/common';
import axiosClient from 'utils/axiosClient';
import { MenuCsv, MenuDetail } from '../../models/SubTitleMenu';

export interface SubTitleMenuResponse {
  status: string;
  message: string;
  data: MenuDetail[];
}

const service = {
  getSubTitleMenus(
    name: string,
    code: string,
    deleteFlg: number,
    expiredDate: string,
    menuPos: string
  ): Promise<SubTitleMenuResponse> {
    const url = `get-sub-title-menus?name=${name}&code=${code}&delete_flg=${deleteFlg}&expired_date=${expiredDate}&menu_pos=${menuPos}`;
    return axiosClient.get(url);
  },
  deleteSubTitleMenus(ids: string): Promise<SubTitleMenuResponse> {
    const body = {
      ids: ids,
    };
    const url = `sub-title-menu/delete-multi`;
    return axiosClient.post(url, body);
  },
  restoreDelete(id: number): Promise<SubTitleMenuResponse> {
    const body = {
      id: id,
    };
    const url = `sub-title-menu/restore-delete`;
    return axiosClient.post(url, body);
  },
  getMenuImportCsvTemplate(): Promise<Blob> {
    const url = `/get-csv-template`;
    return axiosClient.get(url, { responseType: 'blob' });
  },
  importSubTitleMenu(data: MenuCsv[]): Promise<CommonResponse<null>> {
    const url = `/import-sub-title-menu`;
    return axiosClient.post(url, data);
  },
};

export default service;
